import { maxWidth } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import styled from 'styled-components'

const NumbersCard = styled.div`
  display: flex;
  flex-direction: column;
  aligh-items: center;
  text-align: center;
  flex: 1 1 360px;
`

NumbersCard.Number = styled.div`
  font-weight: 500;
  font-size: 110px;
  line-height: 1.22;
  color: #888;

    ${maxWidth(vars.breakpoints.tablet)`
        font-size: 90px;
  `}
`
NumbersCard.Text = styled.p`
    font-size: 20px;
    line-height: 150%;
    text-transform: lowercase;
    color: #323232;
    white-space: pre-line;
`


export default NumbersCard